import { render, staticRenderFns } from "./sales-tips-list.vue?vue&type=template&id=6f4bcb01&scoped=true&"
import script from "./sales-tips-list.vue?vue&type=script&lang=js&"
export * from "./sales-tips-list.vue?vue&type=script&lang=js&"
import style0 from "./sales-tips-list.vue?vue&type=style&index=0&id=6f4bcb01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bcb01",
  null
  
)

export default component.exports